<template>
    <div>
        <div class="mb-3 d-flex align-items-center">
            <div class="mr-2 text-title"> {{ title }}</div>
            <div class="ml-auto">									
                <el-radio-group v-model="pendapatanbungashowtype" size="small">
                    <el-radio-button size="small" label="table"><i class="el-icon-s-fold"></i></el-radio-button>
                    <el-radio-button size="small" label="barchart"><i class="el-icon-s-data"></i></el-radio-button>
                    <el-radio-button size="small" label="linechart"><i class="el-icon-share"></i></el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div>
            <div v-if="pendapatanbungashowtype=='barchart'">
                <BarChart :data="chartdata" :width="barChartSizeTop.width" :height="302"/>
            </div>
            <div v-if="pendapatanbungashowtype=='linechart'" class="mt-4">
                <LineChart :data="chartdata" :width="barChartSizeTop.width" :height="110"/>
            </div>
            <table v-if="pendapatanbungashowtype=='table'" id="table-covenant" class="table-bordered table-striped table-hover" style="width: 100%;">
                <thead>
                    <tr>
                        <td></td>
                        <td class="text-center">Jan</td>
                        <td class="text-center">Feb</td>
                        <td class="text-center">Mar</td>
                        <td class="text-center">Apr</td>
                        <td class="text-center">May</td>
                        <td class="text-center">Jun</td>
                        <td class="text-center">Jul</td>
                        <td class="text-center">Aug</td>
                        <td class="text-center">Sep</td>
                        <td class="text-center">Oct</td>
                        <td class="text-center">Nov</td>
                        <td class="text-center">Dec</td>
                        <td class="text-center text-bold">Ytd</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key, index) in tabledata" :key="index">
                        <td><b>{{ item.title }}</b></td>
                        <td class="text-right">{{ formatNum(item.jan) }}</td>
                        <td class="text-right">{{ formatNum(item.feb) }}</td>
                        <td class="text-right">{{ formatNum(item.mar) }}</td>
                        <td class="text-right">{{ formatNum(item.apr) }}</td>
                        <td class="text-right">{{ formatNum(item.may) }}</td>
                        <td class="text-right">{{ formatNum(item.jun) }}</td>
                        <td class="text-right">{{ formatNum(item.jul) }}</td>
                        <td class="text-right">{{ formatNum(item.aug) }}</td>
                        <td class="text-right">{{ formatNum(item.sep) }}</td>
                        <td class="text-right">{{ formatNum(item.oct) }}</td>
                        <td class="text-right">{{ formatNum(item.nov) }}</td>
                        <td class="text-right">{{ formatNum(item.dec) }}</td>
                        <td class="text-right text-bold">{{ formatNum(item.ytd) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>TOTAL</td>
                        <td class="text-right" v-for="month in shortmonthsname" :key="month">{{ formatNum(summary[month] || 0) }}</td>
                        <td class="text-right">{{ formatNum(totalytd) }}</td>
                        <!--
                        <td class="text-right">10,965,903,311</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                        <td class="text-right">0</td>
                    -->
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import BarChart from '@/components/chart/BarChart.js'
import LineChart from '@/components/chart/LineChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'

import { BungaPosition } from '@/data/treasury/Bunga.js'
import { BungaChartData } from '@/data/treasury/BungaChart.js'

export default {
    extends: Treasury,
    components:{ BarChart, LineChart },
    props: {
        id: {
            type: String,
            default: '',
            //required: false,
        }
    },
    setup() {
        
    },
    mounted() {
        //this.setBungaData()
        this.getData()
    },
    data() {
        return {
            title: 'PENDAPATAN BUNGA ' + Penanggalan().tahun,
            tabledata: [],
            chartdata: [],
            pendapatanbungashowtype: 'table',
            barChartSizeTop: {
				width:500,
				height:200,
			},
            loading : {
                table: true,
                chart: true,
            }
        }
    }, 
    methods: {
        setBungaData() {
			this.tabledata = BungaPosition;
			this.chartdata = this.processBarChart(BungaChartData, "TitleName", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
		},

		pendapatanBungaShow(type) {
			this.pendapatanbungashowtype = type
		},

        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/pendapatanbunga?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			//this.urlRequestParams+='&tahun='+this.year

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					let balanceData = response.data.data.data;
					this.title = response.data.data.title.toUpperCase();
                    //this.setCashNonCashData(balanceData)
                    //console.log(JSON.stringify(balanceData));
                    if(response.data.data.data_chart) {
                        this.chartdata = this.processBarChart(response.data.data.data_chart, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
                    }

                    if(response.data.data.data_table) {
                        this.tabledata = response.data.data.data_table;
                    }
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },
		
    },

    computed: {
        summary() {
            let summary = {};
            this.shortmonthsname.forEach(month => {
                summary[month] = 0;
            });
            this.tabledata.forEach(item => {
                this.shortmonthsname.forEach(month => {
                if (item[month] !== null) {
                    summary[month] += parseFloat(item[month]);
                }
                });
            });
            return summary;
        },
        totalytd() {
            let summary =0;
            this.tabledata.forEach(item => {
                summary += parseFloat(item.ytd);
            });
            return summary;
        },
    }
}
</script>

<style>

</style>